import React from 'react';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import classNames from 'classnames/bind';
import styles from './mulch-tooltip.module.scss';

const cx = classNames.bind(styles);

export const MulchTooltip = () => {

  const ClickToCloseContent = React.forwardRef(function Content(props, ref) {
    return (
      <div className={cx('calculator__mulch-tooltip')} ref={ref}>
        <p className={cx('calculator__mulch-tooltip-header')}>What kind should I choose?</p>
        <div>
          <p className={cx('calculator__mulch-tooltip-description')}>
            <span className={cx('calculator__mulch-tooltip-title')}>Wood mulch</span>
            &nbsp;breaks down after a season or two and needs to be reapplied.
            &nbsp;It actually enhances the soil by adding vital nutrients as it deteriorates.
          </p>
          <p className={cx('calculator__mulch-tooltip-description')}>
            <span className={cx('calculator__mulch-tooltip-title')}>Rubber mulch</span>
            &nbsp;is more permanent, but does not improve the soil structure.
          </p>
          <p className={cx('calculator__mulch-tooltip-description')}>
            <span className={cx('calculator__mulch-tooltip-title')}>Top Soil</span>
            &nbsp;is a ready-to-use soil useful for filling in holes and patching bare spots on lawns.
          </p>
        </div>
      </div>
    );
  });
  return (
    <>
      <span className={cx('calculator__mulch-tooltip-icon')} />
      <Tooltip channel="desktop" placement="bottom-start" closeButton content={<ClickToCloseContent />}>
        <button className={cx('calculator__mulch-tooltip-button')} type="button">What kind should I choose?</button>
      </Tooltip>
    </>
  );
};
